import React from 'react';
export function Hero() {
  return <section className="relative bg-primary py-24 lg:py-32 overflow-hidden" data-id="element-166">
      <div className="absolute inset-0 bg-[url('https://cdn.magicpatterns.com/uploads/9EX9kVoUoAG6ZGT1BGn2to/About-Magnus-Software-App-Development.png')] bg-cover bg-center" data-id="element-167" />
      <div className="absolute inset-0 bg-primary/40" data-id="element-168" />
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-169">
        <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-6 tracking-tight load-fade-in-up stagger-1" data-id="element-170">
          About Magnus Software
        </h1>
        <p className="text-xl text-blue-100 max-w-3xl mx-auto leading-relaxed load-fade-in-up stagger-2" data-id="element-171">
          A trusted partner in custom software development, delivering premium,
          scalable solutions for enterprise clients by referral only.
        </p>
      </div>
    </section>;
}